// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: stcs_wapp_svc_org.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { grpc } from "@improbable-eng/grpc-web";
import { BrowserHeaders } from "browser-headers";
import { Observable } from "rxjs";
import { take } from "rxjs/operators";
import { GenericPayloadResponse } from "./stcs_commons.entity";
import { StcsCompRoleEnum, stcsCompRoleEnumFromJSON, stcsCompRoleEnumToJSON } from "./stcs_enums.entity";

export const protobufPackage = "stcs_cmw";

export interface OrgUserAddRequest {
  ref_id_user: string;
  ref_id_org: string;
  comp_role: StcsCompRoleEnum;
  ref_id_comp_list: string[];
  email: string;
  name_display: string;
  name_first: string;
  name_last: string;
  title?: string | undefined;
  redirect_url: string;
}

export interface OrgCompSortListRequest {
  ref_id_user: string;
  ref_id_org: string;
  comp_list_sort_index_by_id: string[];
}

export interface OrgGetRequest {
  ref_id_user: string;
  ref_id_org: string;
}

export interface OrgUserListRequest {
  ref_id_user: string;
  ref_id_org: string;
}

export interface OrgListRequest {
  ref_id_user: string;
}

export interface OrgCreateRequest {
  display_name: string;
  ref_id_user: string;
  term_of_services_accepted: boolean;
  privacy_policy_accepted: boolean;
  referral_source_text: string;
}

export interface OrgUserDelRequest {
  ref_id_user_requesting: string;
  ref_id_user_to_be_deleted: string;
  ref_id_org: string;
}

export interface OrgUpdateRequest {
  ref_id_user: string;
  ref_id_org: string;
  display_name: string;
  fpna_currency: string;
  fpna_country: string;
  fpna_industry: number;
  fpna_fye_month: number;
}

export interface OrgUserUpdateAccessRequest {
  ref_id_user_requesting: string;
  ref_id_org: string;
  ref_id_user_update_candidate: string;
  comp_role: StcsCompRoleEnum;
  ref_id_comp_list: string[];
}

export interface OrgDeleteRequest {
  ref_id_user: string;
  ref_id_org: string;
}

function createBaseOrgUserAddRequest(): OrgUserAddRequest {
  return {
    ref_id_user: "",
    ref_id_org: "",
    comp_role: 0,
    ref_id_comp_list: [],
    email: "",
    name_display: "",
    name_first: "",
    name_last: "",
    title: undefined,
    redirect_url: "",
  };
}

export const OrgUserAddRequest: MessageFns<OrgUserAddRequest> = {
  encode(message: OrgUserAddRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.comp_role !== 0) {
      writer.uint32(24).int32(message.comp_role);
    }
    for (const v of message.ref_id_comp_list) {
      writer.uint32(34).string(v!);
    }
    if (message.email !== "") {
      writer.uint32(42).string(message.email);
    }
    if (message.name_display !== "") {
      writer.uint32(50).string(message.name_display);
    }
    if (message.name_first !== "") {
      writer.uint32(58).string(message.name_first);
    }
    if (message.name_last !== "") {
      writer.uint32(66).string(message.name_last);
    }
    if (message.title !== undefined) {
      writer.uint32(74).string(message.title);
    }
    if (message.redirect_url !== "") {
      writer.uint32(82).string(message.redirect_url);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrgUserAddRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrgUserAddRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.comp_role = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.ref_id_comp_list.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.name_display = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.name_first = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.name_last = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.redirect_url = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrgUserAddRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      comp_role: isSet(object.comp_role) ? stcsCompRoleEnumFromJSON(object.comp_role) : 0,
      ref_id_comp_list: globalThis.Array.isArray(object?.ref_id_comp_list)
        ? object.ref_id_comp_list.map((e: any) => globalThis.String(e))
        : [],
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      name_display: isSet(object.name_display) ? globalThis.String(object.name_display) : "",
      name_first: isSet(object.name_first) ? globalThis.String(object.name_first) : "",
      name_last: isSet(object.name_last) ? globalThis.String(object.name_last) : "",
      title: isSet(object.title) ? globalThis.String(object.title) : undefined,
      redirect_url: isSet(object.redirect_url) ? globalThis.String(object.redirect_url) : "",
    };
  },

  toJSON(message: OrgUserAddRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.comp_role !== 0) {
      obj.comp_role = stcsCompRoleEnumToJSON(message.comp_role);
    }
    if (message.ref_id_comp_list?.length) {
      obj.ref_id_comp_list = message.ref_id_comp_list;
    }
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.name_display !== "") {
      obj.name_display = message.name_display;
    }
    if (message.name_first !== "") {
      obj.name_first = message.name_first;
    }
    if (message.name_last !== "") {
      obj.name_last = message.name_last;
    }
    if (message.title !== undefined) {
      obj.title = message.title;
    }
    if (message.redirect_url !== "") {
      obj.redirect_url = message.redirect_url;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrgUserAddRequest>, I>>(base?: I): OrgUserAddRequest {
    return OrgUserAddRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrgUserAddRequest>, I>>(object: I): OrgUserAddRequest {
    const message = createBaseOrgUserAddRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.comp_role = object.comp_role ?? 0;
    message.ref_id_comp_list = object.ref_id_comp_list?.map((e) => e) || [];
    message.email = object.email ?? "";
    message.name_display = object.name_display ?? "";
    message.name_first = object.name_first ?? "";
    message.name_last = object.name_last ?? "";
    message.title = object.title ?? undefined;
    message.redirect_url = object.redirect_url ?? "";
    return message;
  },
};

function createBaseOrgCompSortListRequest(): OrgCompSortListRequest {
  return { ref_id_user: "", ref_id_org: "", comp_list_sort_index_by_id: [] };
}

export const OrgCompSortListRequest: MessageFns<OrgCompSortListRequest> = {
  encode(message: OrgCompSortListRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    for (const v of message.comp_list_sort_index_by_id) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrgCompSortListRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrgCompSortListRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.comp_list_sort_index_by_id.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrgCompSortListRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      comp_list_sort_index_by_id: globalThis.Array.isArray(object?.comp_list_sort_index_by_id)
        ? object.comp_list_sort_index_by_id.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: OrgCompSortListRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.comp_list_sort_index_by_id?.length) {
      obj.comp_list_sort_index_by_id = message.comp_list_sort_index_by_id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrgCompSortListRequest>, I>>(base?: I): OrgCompSortListRequest {
    return OrgCompSortListRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrgCompSortListRequest>, I>>(object: I): OrgCompSortListRequest {
    const message = createBaseOrgCompSortListRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.comp_list_sort_index_by_id = object.comp_list_sort_index_by_id?.map((e) => e) || [];
    return message;
  },
};

function createBaseOrgGetRequest(): OrgGetRequest {
  return { ref_id_user: "", ref_id_org: "" };
}

export const OrgGetRequest: MessageFns<OrgGetRequest> = {
  encode(message: OrgGetRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrgGetRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrgGetRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrgGetRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
    };
  },

  toJSON(message: OrgGetRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrgGetRequest>, I>>(base?: I): OrgGetRequest {
    return OrgGetRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrgGetRequest>, I>>(object: I): OrgGetRequest {
    const message = createBaseOrgGetRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    return message;
  },
};

function createBaseOrgUserListRequest(): OrgUserListRequest {
  return { ref_id_user: "", ref_id_org: "" };
}

export const OrgUserListRequest: MessageFns<OrgUserListRequest> = {
  encode(message: OrgUserListRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrgUserListRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrgUserListRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrgUserListRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
    };
  },

  toJSON(message: OrgUserListRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrgUserListRequest>, I>>(base?: I): OrgUserListRequest {
    return OrgUserListRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrgUserListRequest>, I>>(object: I): OrgUserListRequest {
    const message = createBaseOrgUserListRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    return message;
  },
};

function createBaseOrgListRequest(): OrgListRequest {
  return { ref_id_user: "" };
}

export const OrgListRequest: MessageFns<OrgListRequest> = {
  encode(message: OrgListRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrgListRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrgListRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrgListRequest {
    return { ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "" };
  },

  toJSON(message: OrgListRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrgListRequest>, I>>(base?: I): OrgListRequest {
    return OrgListRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrgListRequest>, I>>(object: I): OrgListRequest {
    const message = createBaseOrgListRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    return message;
  },
};

function createBaseOrgCreateRequest(): OrgCreateRequest {
  return {
    display_name: "",
    ref_id_user: "",
    term_of_services_accepted: false,
    privacy_policy_accepted: false,
    referral_source_text: "",
  };
}

export const OrgCreateRequest: MessageFns<OrgCreateRequest> = {
  encode(message: OrgCreateRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.display_name !== "") {
      writer.uint32(10).string(message.display_name);
    }
    if (message.ref_id_user !== "") {
      writer.uint32(18).string(message.ref_id_user);
    }
    if (message.term_of_services_accepted !== false) {
      writer.uint32(32).bool(message.term_of_services_accepted);
    }
    if (message.privacy_policy_accepted !== false) {
      writer.uint32(40).bool(message.privacy_policy_accepted);
    }
    if (message.referral_source_text !== "") {
      writer.uint32(50).string(message.referral_source_text);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrgCreateRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrgCreateRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.display_name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.term_of_services_accepted = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.privacy_policy_accepted = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.referral_source_text = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrgCreateRequest {
    return {
      display_name: isSet(object.display_name) ? globalThis.String(object.display_name) : "",
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      term_of_services_accepted: isSet(object.term_of_services_accepted)
        ? globalThis.Boolean(object.term_of_services_accepted)
        : false,
      privacy_policy_accepted: isSet(object.privacy_policy_accepted)
        ? globalThis.Boolean(object.privacy_policy_accepted)
        : false,
      referral_source_text: isSet(object.referral_source_text) ? globalThis.String(object.referral_source_text) : "",
    };
  },

  toJSON(message: OrgCreateRequest): unknown {
    const obj: any = {};
    if (message.display_name !== "") {
      obj.display_name = message.display_name;
    }
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.term_of_services_accepted !== false) {
      obj.term_of_services_accepted = message.term_of_services_accepted;
    }
    if (message.privacy_policy_accepted !== false) {
      obj.privacy_policy_accepted = message.privacy_policy_accepted;
    }
    if (message.referral_source_text !== "") {
      obj.referral_source_text = message.referral_source_text;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrgCreateRequest>, I>>(base?: I): OrgCreateRequest {
    return OrgCreateRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrgCreateRequest>, I>>(object: I): OrgCreateRequest {
    const message = createBaseOrgCreateRequest();
    message.display_name = object.display_name ?? "";
    message.ref_id_user = object.ref_id_user ?? "";
    message.term_of_services_accepted = object.term_of_services_accepted ?? false;
    message.privacy_policy_accepted = object.privacy_policy_accepted ?? false;
    message.referral_source_text = object.referral_source_text ?? "";
    return message;
  },
};

function createBaseOrgUserDelRequest(): OrgUserDelRequest {
  return { ref_id_user_requesting: "", ref_id_user_to_be_deleted: "", ref_id_org: "" };
}

export const OrgUserDelRequest: MessageFns<OrgUserDelRequest> = {
  encode(message: OrgUserDelRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user_requesting !== "") {
      writer.uint32(10).string(message.ref_id_user_requesting);
    }
    if (message.ref_id_user_to_be_deleted !== "") {
      writer.uint32(18).string(message.ref_id_user_to_be_deleted);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(26).string(message.ref_id_org);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrgUserDelRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrgUserDelRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user_requesting = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_user_to_be_deleted = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrgUserDelRequest {
    return {
      ref_id_user_requesting: isSet(object.ref_id_user_requesting)
        ? globalThis.String(object.ref_id_user_requesting)
        : "",
      ref_id_user_to_be_deleted: isSet(object.ref_id_user_to_be_deleted)
        ? globalThis.String(object.ref_id_user_to_be_deleted)
        : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
    };
  },

  toJSON(message: OrgUserDelRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user_requesting !== "") {
      obj.ref_id_user_requesting = message.ref_id_user_requesting;
    }
    if (message.ref_id_user_to_be_deleted !== "") {
      obj.ref_id_user_to_be_deleted = message.ref_id_user_to_be_deleted;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrgUserDelRequest>, I>>(base?: I): OrgUserDelRequest {
    return OrgUserDelRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrgUserDelRequest>, I>>(object: I): OrgUserDelRequest {
    const message = createBaseOrgUserDelRequest();
    message.ref_id_user_requesting = object.ref_id_user_requesting ?? "";
    message.ref_id_user_to_be_deleted = object.ref_id_user_to_be_deleted ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    return message;
  },
};

function createBaseOrgUpdateRequest(): OrgUpdateRequest {
  return {
    ref_id_user: "",
    ref_id_org: "",
    display_name: "",
    fpna_currency: "",
    fpna_country: "",
    fpna_industry: 0,
    fpna_fye_month: 0,
  };
}

export const OrgUpdateRequest: MessageFns<OrgUpdateRequest> = {
  encode(message: OrgUpdateRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.display_name !== "") {
      writer.uint32(26).string(message.display_name);
    }
    if (message.fpna_currency !== "") {
      writer.uint32(34).string(message.fpna_currency);
    }
    if (message.fpna_country !== "") {
      writer.uint32(42).string(message.fpna_country);
    }
    if (message.fpna_industry !== 0) {
      writer.uint32(48).uint32(message.fpna_industry);
    }
    if (message.fpna_fye_month !== 0) {
      writer.uint32(56).uint32(message.fpna_fye_month);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrgUpdateRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrgUpdateRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.display_name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.fpna_currency = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fpna_country = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.fpna_industry = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.fpna_fye_month = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrgUpdateRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      display_name: isSet(object.display_name) ? globalThis.String(object.display_name) : "",
      fpna_currency: isSet(object.fpna_currency) ? globalThis.String(object.fpna_currency) : "",
      fpna_country: isSet(object.fpna_country) ? globalThis.String(object.fpna_country) : "",
      fpna_industry: isSet(object.fpna_industry) ? globalThis.Number(object.fpna_industry) : 0,
      fpna_fye_month: isSet(object.fpna_fye_month) ? globalThis.Number(object.fpna_fye_month) : 0,
    };
  },

  toJSON(message: OrgUpdateRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.display_name !== "") {
      obj.display_name = message.display_name;
    }
    if (message.fpna_currency !== "") {
      obj.fpna_currency = message.fpna_currency;
    }
    if (message.fpna_country !== "") {
      obj.fpna_country = message.fpna_country;
    }
    if (message.fpna_industry !== 0) {
      obj.fpna_industry = Math.round(message.fpna_industry);
    }
    if (message.fpna_fye_month !== 0) {
      obj.fpna_fye_month = Math.round(message.fpna_fye_month);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrgUpdateRequest>, I>>(base?: I): OrgUpdateRequest {
    return OrgUpdateRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrgUpdateRequest>, I>>(object: I): OrgUpdateRequest {
    const message = createBaseOrgUpdateRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.display_name = object.display_name ?? "";
    message.fpna_currency = object.fpna_currency ?? "";
    message.fpna_country = object.fpna_country ?? "";
    message.fpna_industry = object.fpna_industry ?? 0;
    message.fpna_fye_month = object.fpna_fye_month ?? 0;
    return message;
  },
};

function createBaseOrgUserUpdateAccessRequest(): OrgUserUpdateAccessRequest {
  return {
    ref_id_user_requesting: "",
    ref_id_org: "",
    ref_id_user_update_candidate: "",
    comp_role: 0,
    ref_id_comp_list: [],
  };
}

export const OrgUserUpdateAccessRequest: MessageFns<OrgUserUpdateAccessRequest> = {
  encode(message: OrgUserUpdateAccessRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user_requesting !== "") {
      writer.uint32(10).string(message.ref_id_user_requesting);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_user_update_candidate !== "") {
      writer.uint32(26).string(message.ref_id_user_update_candidate);
    }
    if (message.comp_role !== 0) {
      writer.uint32(32).int32(message.comp_role);
    }
    for (const v of message.ref_id_comp_list) {
      writer.uint32(42).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrgUserUpdateAccessRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrgUserUpdateAccessRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user_requesting = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_user_update_candidate = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.comp_role = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.ref_id_comp_list.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrgUserUpdateAccessRequest {
    return {
      ref_id_user_requesting: isSet(object.ref_id_user_requesting)
        ? globalThis.String(object.ref_id_user_requesting)
        : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_user_update_candidate: isSet(object.ref_id_user_update_candidate)
        ? globalThis.String(object.ref_id_user_update_candidate)
        : "",
      comp_role: isSet(object.comp_role) ? stcsCompRoleEnumFromJSON(object.comp_role) : 0,
      ref_id_comp_list: globalThis.Array.isArray(object?.ref_id_comp_list)
        ? object.ref_id_comp_list.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: OrgUserUpdateAccessRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user_requesting !== "") {
      obj.ref_id_user_requesting = message.ref_id_user_requesting;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_user_update_candidate !== "") {
      obj.ref_id_user_update_candidate = message.ref_id_user_update_candidate;
    }
    if (message.comp_role !== 0) {
      obj.comp_role = stcsCompRoleEnumToJSON(message.comp_role);
    }
    if (message.ref_id_comp_list?.length) {
      obj.ref_id_comp_list = message.ref_id_comp_list;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrgUserUpdateAccessRequest>, I>>(base?: I): OrgUserUpdateAccessRequest {
    return OrgUserUpdateAccessRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrgUserUpdateAccessRequest>, I>>(object: I): OrgUserUpdateAccessRequest {
    const message = createBaseOrgUserUpdateAccessRequest();
    message.ref_id_user_requesting = object.ref_id_user_requesting ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_user_update_candidate = object.ref_id_user_update_candidate ?? "";
    message.comp_role = object.comp_role ?? 0;
    message.ref_id_comp_list = object.ref_id_comp_list?.map((e) => e) || [];
    return message;
  },
};

function createBaseOrgDeleteRequest(): OrgDeleteRequest {
  return { ref_id_user: "", ref_id_org: "" };
}

export const OrgDeleteRequest: MessageFns<OrgDeleteRequest> = {
  encode(message: OrgDeleteRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrgDeleteRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrgDeleteRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrgDeleteRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
    };
  },

  toJSON(message: OrgDeleteRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrgDeleteRequest>, I>>(base?: I): OrgDeleteRequest {
    return OrgDeleteRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrgDeleteRequest>, I>>(object: I): OrgDeleteRequest {
    const message = createBaseOrgDeleteRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    return message;
  },
};

export interface StcsWappSvcOrg {
  org_comp_sort_list(
    request: DeepPartial<OrgCompSortListRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
  org_create(request: DeepPartial<OrgCreateRequest>, metadata?: grpc.Metadata): Observable<GenericPayloadResponse>;
  org_get(request: DeepPartial<OrgGetRequest>, metadata?: grpc.Metadata): Observable<GenericPayloadResponse>;
  org_list(request: DeepPartial<OrgListRequest>, metadata?: grpc.Metadata): Observable<GenericPayloadResponse>;
  org_update(request: DeepPartial<OrgUpdateRequest>, metadata?: grpc.Metadata): Observable<GenericPayloadResponse>;
  org_user_add(request: DeepPartial<OrgUserAddRequest>, metadata?: grpc.Metadata): Observable<GenericPayloadResponse>;
  org_user_del(request: DeepPartial<OrgUserDelRequest>, metadata?: grpc.Metadata): Observable<GenericPayloadResponse>;
  org_user_list(request: DeepPartial<OrgUserListRequest>, metadata?: grpc.Metadata): Observable<GenericPayloadResponse>;
  org_user_update_access(
    request: DeepPartial<OrgUserUpdateAccessRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
  org_delete(request: DeepPartial<OrgDeleteRequest>, metadata?: grpc.Metadata): Observable<GenericPayloadResponse>;
}

export class StcsWappSvcOrgClientImpl implements StcsWappSvcOrg {
  private readonly rpc: Rpc;

  constructor(rpc: Rpc) {
    this.rpc = rpc;
    this.org_comp_sort_list = this.org_comp_sort_list.bind(this);
    this.org_create = this.org_create.bind(this);
    this.org_get = this.org_get.bind(this);
    this.org_list = this.org_list.bind(this);
    this.org_update = this.org_update.bind(this);
    this.org_user_add = this.org_user_add.bind(this);
    this.org_user_del = this.org_user_del.bind(this);
    this.org_user_list = this.org_user_list.bind(this);
    this.org_user_update_access = this.org_user_update_access.bind(this);
    this.org_delete = this.org_delete.bind(this);
  }

  org_comp_sort_list(
    request: DeepPartial<OrgCompSortListRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(StcsWappSvcOrgorg_comp_sort_listDesc, OrgCompSortListRequest.fromPartial(request), metadata);
  }

  org_create(request: DeepPartial<OrgCreateRequest>, metadata?: grpc.Metadata): Observable<GenericPayloadResponse> {
    return this.rpc.unary(StcsWappSvcOrgorg_createDesc, OrgCreateRequest.fromPartial(request), metadata);
  }

  org_get(request: DeepPartial<OrgGetRequest>, metadata?: grpc.Metadata): Observable<GenericPayloadResponse> {
    return this.rpc.unary(StcsWappSvcOrgorg_getDesc, OrgGetRequest.fromPartial(request), metadata);
  }

  org_list(request: DeepPartial<OrgListRequest>, metadata?: grpc.Metadata): Observable<GenericPayloadResponse> {
    return this.rpc.unary(StcsWappSvcOrgorg_listDesc, OrgListRequest.fromPartial(request), metadata);
  }

  org_update(request: DeepPartial<OrgUpdateRequest>, metadata?: grpc.Metadata): Observable<GenericPayloadResponse> {
    return this.rpc.unary(StcsWappSvcOrgorg_updateDesc, OrgUpdateRequest.fromPartial(request), metadata);
  }

  org_user_add(request: DeepPartial<OrgUserAddRequest>, metadata?: grpc.Metadata): Observable<GenericPayloadResponse> {
    return this.rpc.unary(StcsWappSvcOrgorg_user_addDesc, OrgUserAddRequest.fromPartial(request), metadata);
  }

  org_user_del(request: DeepPartial<OrgUserDelRequest>, metadata?: grpc.Metadata): Observable<GenericPayloadResponse> {
    return this.rpc.unary(StcsWappSvcOrgorg_user_delDesc, OrgUserDelRequest.fromPartial(request), metadata);
  }

  org_user_list(
    request: DeepPartial<OrgUserListRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(StcsWappSvcOrgorg_user_listDesc, OrgUserListRequest.fromPartial(request), metadata);
  }

  org_user_update_access(
    request: DeepPartial<OrgUserUpdateAccessRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcOrgorg_user_update_accessDesc,
      OrgUserUpdateAccessRequest.fromPartial(request),
      metadata,
    );
  }

  org_delete(request: DeepPartial<OrgDeleteRequest>, metadata?: grpc.Metadata): Observable<GenericPayloadResponse> {
    return this.rpc.unary(StcsWappSvcOrgorg_deleteDesc, OrgDeleteRequest.fromPartial(request), metadata);
  }
}

export const StcsWappSvcOrgDesc = { serviceName: "stcs_cmw.StcsWappSvcOrg" };

export const StcsWappSvcOrgorg_comp_sort_listDesc: UnaryMethodDefinitionish = {
  methodName: "org_comp_sort_list",
  service: StcsWappSvcOrgDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return OrgCompSortListRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcOrgorg_createDesc: UnaryMethodDefinitionish = {
  methodName: "org_create",
  service: StcsWappSvcOrgDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return OrgCreateRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcOrgorg_getDesc: UnaryMethodDefinitionish = {
  methodName: "org_get",
  service: StcsWappSvcOrgDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return OrgGetRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcOrgorg_listDesc: UnaryMethodDefinitionish = {
  methodName: "org_list",
  service: StcsWappSvcOrgDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return OrgListRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcOrgorg_updateDesc: UnaryMethodDefinitionish = {
  methodName: "org_update",
  service: StcsWappSvcOrgDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return OrgUpdateRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcOrgorg_user_addDesc: UnaryMethodDefinitionish = {
  methodName: "org_user_add",
  service: StcsWappSvcOrgDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return OrgUserAddRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcOrgorg_user_delDesc: UnaryMethodDefinitionish = {
  methodName: "org_user_del",
  service: StcsWappSvcOrgDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return OrgUserDelRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcOrgorg_user_listDesc: UnaryMethodDefinitionish = {
  methodName: "org_user_list",
  service: StcsWappSvcOrgDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return OrgUserListRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcOrgorg_user_update_accessDesc: UnaryMethodDefinitionish = {
  methodName: "org_user_update_access",
  service: StcsWappSvcOrgDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return OrgUserUpdateAccessRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcOrgorg_deleteDesc: UnaryMethodDefinitionish = {
  methodName: "org_delete",
  service: StcsWappSvcOrgDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return OrgDeleteRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

interface UnaryMethodDefinitionishR extends grpc.UnaryMethodDefinition<any, any> {
  requestStream: any;
  responseStream: any;
}

type UnaryMethodDefinitionish = UnaryMethodDefinitionishR;

interface Rpc {
  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    request: any,
    metadata: grpc.Metadata | undefined,
  ): Observable<any>;
}

export class GrpcWebImpl {
  private host: string;
  private options: {
    transport?: grpc.TransportFactory;

    debug?: boolean;
    metadata?: grpc.Metadata;
    upStreamRetryCodes?: number[];
  };

  constructor(
    host: string,
    options: {
      transport?: grpc.TransportFactory;

      debug?: boolean;
      metadata?: grpc.Metadata;
      upStreamRetryCodes?: number[];
    },
  ) {
    this.host = host;
    this.options = options;
  }

  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    _request: any,
    metadata: grpc.Metadata | undefined,
  ): Observable<any> {
    const request = { ..._request, ...methodDesc.requestType };
    const maybeCombinedMetadata = metadata && this.options.metadata
      ? new BrowserHeaders({ ...this.options?.metadata.headersMap, ...metadata?.headersMap })
      : metadata ?? this.options.metadata;
    return new Observable((observer) => {
      grpc.unary(methodDesc, {
        request,
        host: this.host,
        metadata: maybeCombinedMetadata ?? {},
        ...(this.options.transport !== undefined ? { transport: this.options.transport } : {}),
        debug: this.options.debug ?? false,
        onEnd: (next) => {
          if (next.status !== 0) {
            const err = new GrpcWebError(next.statusMessage, next.status, next.trailers);
            observer.error(err);
          } else {
            observer.next(next.message as any);
            observer.complete();
          }
        },
      });
    }).pipe(take(1));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export class GrpcWebError extends globalThis.Error {
  constructor(message: string, public code: grpc.Code, public metadata: grpc.Metadata) {
    super(message);
  }
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
